import PasswordResetForm from './password-reset-form'
export default PasswordResetForm;